"use client"

import { Card, CardContent } from "@/components/ui/card"
import { useState } from "react"
import { ArrayItemRenderer } from "./array-item-renderer"
import type React from "react"

export interface CardArrayPreviewProps {
  item: any
  dataSchema: any
  data?: any
  parentData?: any
  parentPath?: string[]
  editable?: boolean
  draggable?: boolean
  onFieldChange?: (path: string[], value: any) => void
  renderItem?: (item: any, parentData?: any, parentScope?: string, parentPath?: string[]) => React.ReactNode
  tabIndex?: number
  componentPath?: number[]
  onReorderKeys?: (tabIndex: number, componentPath: number[], fromIndex: number, toIndex: number) => void
  onReorderField?: (
    tabIndex: number,
    componentPath: number[],
    fromRow: number,
    fromCol: number,
    toRow: number,
    toCol: number,
  ) => void
  onRemoveField?: (tabIndex: number, componentPath: number[], rowIndex: number, colIndex: number) => void
}

export function CardArrayPreview({
  item,
  dataSchema,
  data,
  parentData,
  parentPath = [],
  editable = false,
  draggable = true,
  onFieldChange,
  renderItem,
  tabIndex,
  componentPath,
  onReorderField,
  onRemoveField,
}: CardArrayPreviewProps) {
  const [draggedPosition, setDraggedPosition] = useState<{ row: number; col: number } | null>(null)
  const [dragOverPosition, setDragOverPosition] = useState<{ row: number; col: number } | null>(null)





  const indexKey = item.index || item.key
  const resolvedParentData = parentData || data


  console.log(
    "[v0] CardArrayPreview - resolvedParentData keys:",
    resolvedParentData ? Object.keys(resolvedParentData) : "no data",
  )

  let arrayData = null
  let arrayKey = ""

  if (item.scope) {
    // New format: use scope path
    const scopeParts = item.scope.split("/").filter((p: string) => p && p !== "#" && p !== "properties")
    arrayKey = scopeParts[scopeParts.length - 1] || ""


    let current = resolvedParentData
    for (const part of scopeParts) {
      if (current && current[part] !== undefined) {
        current = current[part]
      } else {
        current = null
        break
      }
    }
    arrayData = current
  } else if (indexKey) {
    // Old format: use index or key directly
    arrayKey = indexKey
    arrayData = resolvedParentData?.[indexKey] || null


  }





  const finalArrayData = Array.isArray(arrayData) ? arrayData : []



  const currentPath = item.scope
    ? [...parentPath, ...item.scope.split("/").filter((p: string) => p && p !== "#" && p !== "properties")]
    : [...parentPath, arrayKey]

  const handleFieldDragStart = (e: React.DragEvent, rowIndex: number, colIndex: number) => {
    setDraggedPosition({ row: rowIndex, col: colIndex })
  }

  const handleFieldDragOver = (e: React.DragEvent, rowIndex: number, colIndex: number) => {
    e.preventDefault()
    setDragOverPosition({ row: rowIndex, col: colIndex })
  }

  const handleFieldDragLeave = () => {
    setDragOverPosition(null)
  }

  const handleFieldDrop = (e: React.DragEvent, toRow: number, toCol: number) => {
    e.preventDefault()
    if (draggedPosition && onReorderField && tabIndex !== undefined && componentPath) {
      onReorderField(tabIndex, componentPath, draggedPosition.row, draggedPosition.col, toRow, toCol)
    }
    setDraggedPosition(null)
    setDragOverPosition(null)
  }

  const handleFieldDragEnd = () => {
    setDraggedPosition(null)
    setDragOverPosition(null)
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold">{item.header || "Items"}</h3>
        {finalArrayData.length > 0 && (
          <span className="text-sm text-muted-foreground">
            {finalArrayData.length} {finalArrayData.length === 1 ? "item" : "items"}
          </span>
        )}
      </div>
      {finalArrayData.length > 0 ? (
        finalArrayData.map((itemData: any, dataIndex: number) => (
          <ArrayItemRenderer
            key={dataIndex}
            itemData={itemData}
            dataIndex={dataIndex}
            template={item.template || item}
            itemScope={arrayKey}
            currentPath={[...currentPath, String(dataIndex)]}
            editable={editable}
            draggable={draggable}
            onFieldChange={onFieldChange}
            onReorderField={onReorderField}
            onRemoveField={onRemoveField}
            renderItem={renderItem}
            tabIndex={tabIndex}
            componentPath={componentPath}
            dataSchema={dataSchema}
            draggedPosition={draggedPosition}
            dragOverPosition={dragOverPosition}
            onFieldDragStart={handleFieldDragStart}
            onFieldDragOver={handleFieldDragOver}
            onFieldDragLeave={handleFieldDragLeave}
            onFieldDrop={handleFieldDrop}
            onFieldDragEnd={handleFieldDragEnd}
          />
        ))
      ) : (
        <Card>
          <CardContent className="py-8 text-center text-muted-foreground">
            {!editable ? "No items to display" : "No data available - add items to see them here"}
          </CardContent>
        </Card>
      )}
    </div>
  )
}

